import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ModuleConfig } from '../../modules/utility/module.js';

var DefaultBuilderLoadable = function DefaultBuilderLoadable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var defaultOptions = {
  defaultLoadable: DefaultBuilderLoadable
};
var config = new ModuleConfig(defaultOptions);
/**
 * Gets current configuration options for builder components
 * @returns {object} Builder component options
 */

var getBuilderComponentOptions = function getBuilderComponentOptions() {
  return config.getAll();
};
/**
 * Configures options for builder components
 * @param {object} options Options to set
 * @param {function|object} options.defaultLoadable The default Loadable component for builder components to render
 */


var setBuilderComponentOptions = function setBuilderComponentOptions(options) {
  if (options.defaultLoadable !== undefined && typeof options.defaultLoadable !== "function" && _typeof(options.defaultLoadable) !== "object") {
    console.warn("Unable to set default builder loadable, component is invalid");
  }

  config.setAll(options);
}; // --- legacy methods ---

/**
 * @deprecated replaced by getBuilderComponentOptions
 */


var getDefaultBuilderLoadable = function getDefaultBuilderLoadable() {
  return getBuilderComponentOptions().defaultLoadable;
};
/**
 * @deprecated replaced by setBuilderComponentOptions
 */


var setDefaultBuilderLoadable = function setDefaultBuilderLoadable(component) {
  return setBuilderComponentOptions({
    defaultLoadable: component
  });
};

export { getBuilderComponentOptions, getDefaultBuilderLoadable, setBuilderComponentOptions, setDefaultBuilderLoadable };
